import { render } from "./MobileInstallsAdmin.vue?vue&type=template&id=7dcc1c2a&scoped=true"
import script from "./MobileInstallsAdmin.vue?vue&type=script&lang=js"
export * from "./MobileInstallsAdmin.vue?vue&type=script&lang=js"

import "@/styles/mobile-admin.css?vue&type=style&index=0&id=7dcc1c2a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcc1c2a"]])

export default __exports__